import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { useUserDetails } from 'api/useUserDetails';
import { EEventsType } from 'constants/enums';
import { useBigQueryEventsTracking } from 'hooks/useBigQueryTracking';
import { trackMixpanelEvent } from 'utils/mixpanelClient';

import Button from 'components/Button/Button';
import Typography from 'components/Typography/Typography';

import { ImportTemplateButton } from './ImportButton';

export const TemplatesStudioMainPageHeader: React.FC = () => {
  const { publisherId } = useParams();
  const navigate = useNavigate();
  const { trackBigQueryEvent } = useBigQueryEventsTracking();
  const { userDetails } = useUserDetails();

  const handlePrimaryButtonClick = () => {
    navigate('./form');

    trackMixpanelEvent(EEventsType.DASHBOARD_TEMPLATE_ACTION, {
      publisher_id: publisherId,
      user_id: userDetails?.userId,
      company_id: userDetails?.company,
      templateAction: 'create',
      isActiveTemplate: false
    });
    trackBigQueryEvent({
      eventName: EEventsType.DASHBOARD_TEMPLATE_ACTION,
      publisherId: publisherId,
      userId: userDetails?.userId,
      action: 'create',
      is_active: false
    });
  };

  return (
    <div className="flex justify-between items-center min-h-10 mb-7">
      <div className="flex flex-col gap-1">
        <Typography className="text-hd-h3">{'Template Studio'}</Typography>
        <Typography
          className="text-sm text-md font-normal"
          style={{ color: 'var(--base-muted-foreground)' }}
        >
          {'Select or create a custom template layout for your store'}
        </Typography>
      </div>
      <div className="flex items-center gap-2.5">
        <ImportTemplateButton />
        <Button
          isCreateButton={true}
          onClick={handlePrimaryButtonClick}
          data-testid="TemplatesStudio-CreateTemplate"
        >
          {'Create Template'}
        </Button>
      </div>
    </div>
  );
};
